import {
  AccountDetailReport,
  ApAgingReport,
  ArAgingReport,
  BalanceSheetReport,
  BillDetailReport,
  BillReceiptReport,
  CashflowForecastReport,
  ChartOfAccountsReport,
  ContactDetailReport,
  Contractor1099Report,
  ExpenseBreakdownReport,
  ExpensesByVendorReport,
  FinancialRatiosReport,
  GenericArtifactView,
  InvoiceDetailReport,
  InvoiceDetailView,
  KpiDashboardReport,
  MonthlySummaryView,
  OpenInvoicesReport,
  PnlReport,
  ReportComparisonReport,
  SummaryTextView,
  Tax1099SummaryReport,
  TaxCis300Report,
  TaxCt600Report,
  TaxEstimateReport,
  TaxEstimateUkReport,
  TaxSa103Report,
  TaxScheduleCReport,
  TaxVatReturnReport,
  VendorBalanceReport,
} from './reports';

export function ArtifactContent({ data }: { data: Record<string, unknown> }) {
  if (data.type === 'entity-detail:Bill') {
    return <BillDetailReport data={data} />;
  }
  if (data.entityType === 'Invoice') {
    return <InvoiceDetailView data={data} />;
  }
  if (data.type === 'entity-detail:Invoice') {
    return <InvoiceDetailReport data={data} />;
  }
  if (data.entityType === 'Bill' || data.entityType === 'Purchase') {
    return <BillReceiptReport data={data} />;
  }
  if (data.entityType === 'Account') {
    return <AccountDetailReport data={data} />;
  }
  if (data.entityType === 'Vendor' || data.entityType === 'Customer') {
    return <ContactDetailReport data={data} />;
  }

  if (data.type === 'report:pnl') return <PnlReport data={data} />;
  if (data.type === 'report:balance-sheet') return <BalanceSheetReport data={data} />;
  if (data.type === 'report:expense-breakdown') return <ExpenseBreakdownReport data={data} />;
  if (data.type === 'report:ar-aging') return <ArAgingReport data={data} />;
  if (data.type === 'report:ap-aging') return <ApAgingReport data={data} />;
  if (data.type === 'report:open-invoices') return <OpenInvoicesReport data={data} />;
  if (data.type === 'report:vendor-balance') return <VendorBalanceReport data={data} />;
  if (data.type === 'report:expenses-by-vendor') return <ExpensesByVendorReport data={data} />;
  if (data.type === 'report:chart-of-accounts') return <ChartOfAccountsReport data={data} />;
  if (data.type === 'report:1099') return <Contractor1099Report data={data} />;
  if (data.type === 'report:kpi-dashboard') return <KpiDashboardReport data={data} />;
  if (data.type === 'report:financial-ratios') return <FinancialRatiosReport data={data} />;
  if (data.type === 'report:comparison') return <ReportComparisonReport data={data} />;
  if (data.type === 'report:cashflow-forecast') return <CashflowForecastReport data={data} />;

  if (data.type === 'tax:estimate') return <TaxEstimateReport data={data} />;
  if (data.type === 'tax:estimate-uk') return <TaxEstimateUkReport data={data} />;
  if (data.type === 'tax:schedule-c') return <TaxScheduleCReport data={data} />;
  if (data.type === 'tax:1099-summary') return <Tax1099SummaryReport data={data} />;
  if (data.type === 'tax:sa103') return <TaxSa103Report data={data} />;
  if (data.type === 'tax:vat-return') return <TaxVatReturnReport data={data} />;
  if (data.type === 'tax:cis300') return <TaxCis300Report data={data} />;
  if (data.type === 'tax:ct600') return <TaxCt600Report data={data} />;

  if (data.type === 'monthly-summary' || 'totalRevenue' in data) {
    return <MonthlySummaryView data={data} />;
  }

  if (typeof data.summary === 'string') {
    return <SummaryTextView summary={data.summary} />;
  }

  return <GenericArtifactView data={data} />;
}
